import { P, useScopedSelector } from 'ia-react-core';
import { redirectTo, Section } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CommunicationPreferencesResourceInfo } from '../../../..';
import Constants from '../../../../Constants';
import { CommunicationPreferences } from '../../../../interfaces/CommunicationPreferences';
import { StyledButton } from '../Content.styles';

export interface ServicesSectionProps { }

const ServicesSection: FC<ServicesSectionProps> = () => {
  const { t } = useTranslation('PreferencesTile');
  const navigate = useNavigate();
  const preferences: CommunicationPreferences = useScopedSelector(CommunicationPreferencesResourceInfo.dataDst);

  if (!(preferences?.documentPreferences)) return null;

  const allPreferences = [...preferences.documentPreferences.map((x) => x.preferenceValue), preferences.communicationPreference.preferenceValue];
  const subscriptionRate = Math.round((allPreferences.filter((x) => x === 1).length / allPreferences.length) * 100);

  return (
    <section>
      <Section data-testid="communicationPreferencesSection" name={t('subscriptionEServiceRateLabel')}>
        <P>{subscriptionRate}{t('subscriptionEServiceRateText')}</P>
      </Section>
      <StyledButton data-testid="modifyPreferencesButton" outline onClick={() => redirectTo(Constants.PreferencesCommunicationChangePath, navigate)}>{t('modifybuttonLabel')}</StyledButton>
    </section>
  );
};

export default ServicesSection;
